import ServiceStore from "stores/ServiceStore";
import { RouteType } from "types/RouteType";

const BatchPlantDashboardRoute: RouteType = {
  name: "Batch Plant Dashboard",
  path: "/batch-plant/dashboard",
  layout: "/app",
  group: "Batch Plant",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Batch Plant Dashboard",
      component: () => import("./BatchPlantDashboardHeader"),
      enableRefreshButton: true,
      enableBackButton: true,
    },
    body: {
      component: () => import("./BatchPlantDashboardBody"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      // Load critical batch plant stores
      const promises = [];

      // Load batch orders (equivalent to production orders for concrete)
      const batchOrdersStore = rootStore.batchOrdersStore as ServiceStore;
      if (batchOrdersStore) {
        promises.push(batchOrdersStore.find());
      }

      // Load quality holds
      const holdStore = rootStore.holdStore as ServiceStore;
      if (holdStore) {
        promises.push(holdStore.find());
      }

      // Load job schedules
      const jobScheduleStore = rootStore.jobScheduleStore as ServiceStore;
      if (jobScheduleStore) {
        promises.push(jobScheduleStore.find());
      }

      // Load jobs for filtering
      const jobStore = rootStore.jobStore as ServiceStore;
      if (jobStore) {
        promises.push(jobStore.find());
      }

      // Load products (concrete mix designs)
      const productsStore = rootStore.productsStore as ServiceStore;
      if (productsStore) {
        promises.push(productsStore.find());
      }

      // Load mix designs
      const mixDesignsStore = rootStore.mixDesignsStore as ServiceStore;
      if (mixDesignsStore) {
        promises.push(mixDesignsStore.find());
      }

      // Load trucks
      const trucksStore = rootStore.trucksStore as ServiceStore;
      if (trucksStore) {
        promises.push(trucksStore.find());
      }

      // Load materials (aggregates, cement, etc.)
      const materialsStore = rootStore.materialsStore as ServiceStore;
      if (materialsStore) {
        promises.push(materialsStore.find());
      }

      // Execute all data loading in parallel
      await Promise.all(promises);

      // Load dashboard data after stores are populated
      const viewStore = (rootStore as any).batchPlantDashboardViewStore;
      if (viewStore) {
        await viewStore.loadDashboardData();
      }

      return true;
    } catch (error) {
      console.error("Failed to load batch plant dashboard data:", error);
      return true; // Allow navigation even if data loading fails
    }
  },
  onExit: ({ rootStore }: any) => {
    const viewStore = (rootStore as any).batchPlantDashboardViewStore;
    if (viewStore) {
      viewStore.reset();
    }
  },
};

export default BatchPlantDashboardRoute;
